import { NavLink } from 'react-router-dom';

export const NotFound: React.FC<React.PropsWithChildren> = () => {
  return (
    <>
      <h1>Page not found</h1>
      <p>
        We were not able to find your page, please{' '}
        <NavLink to="/">return home</NavLink>
      </p>
    </>
  );
};
